<template>
  <ab-flow-base-cmp :movable="true" :block="block" class="inter-editor-cmp">

    <ab-flow-link-connector :block="block" type="input" class="ev-run" event="show"/>

    <q-card>

      <q-card-section class="bg-green-8 text-white">
        {{ adType }}
      </q-card-section>
      <q-card-section>
        Placement: {{placement}}
      </q-card-section>

    </q-card>

    <div class="results">
      <ab-flow-link-connector v-for="(e, k) of outEvents" class="q-mt-sm" :block="block" type="output" :event="e" :key="k"/>
    </div>

  </ab-flow-base-cmp>
</template>

<script>

import AbFlowBaseCmp from "ab-flow-designer/src/components/Designer/AbFlowBaseCmp";
import AbFlowLinkConnector from "ab-flow-designer/src/components/Designer/AbFlowLinkConnector";

export default {
  components: { AbFlowBaseCmp, AbFlowLinkConnector},
  inject: ['canvas'],
  props: ['block'],
  name: "FullscreenAdEditorCmp",
  data: () => ({
  }),
  computed: {

    /**
     * Return name
     * @return {{}}
     */
    placement() {
      return this.block.properties?.placementTitle || "n/a"
    },

    /**
     * Out events
     * @return {string[]}
     */
    outEvents() {
      return [...['error', 'success', 'no-ads'], ...(['interstitial-rewarded', 'rewarded'].includes(this.block.properties?.adType) ? ['closed'] : ['skipped'])]
    },

    /**
     * Ad type
     * @return {{}}
     */
    adType() {
      return this.globals.options.adTypes.find(t => t.value === this.block.properties?.adType)?.label || "No type"
    },
  }
}

</script>

<style lang="scss">

.inter-editor-cmp {
  .ev-run {
    left:-12px;
    position: absolute;
    top:calc(50% - 5px);
  }

  .results {
    position: absolute;
    right: -12px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

</style>
